export default function InnerSend() {
    return (<svg id="_20X20_photo_Back" data-name="20X20 photo Back" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
        <g id="Mask_Group_399" data-name="Mask Group 399">
            <g id="Icon" transform="translate(-1.162 -1.163)">
                <path id="Path_21689" data-name="Path 21689" d="M1.214,3.295A1.716,1.716,0,0,1,3.646,1.344L20.214,9.628a1.716,1.716,0,0,1,0,3.07L3.646,20.981a1.716,1.716,0,0,1-2.433-1.951l1.735-6.938,10.074-.93-10.074-.93L1.214,3.295Z" fill="#5d5d5d" fill-rule="evenodd" />
            </g>
        </g>
    </svg>
    )
}